export default "/credits/business/assets/cbe45bb04eda5ee8fae252f213471d23.svg";